const wayToPayMethod = [
  { key: '01', value: 'Efectivo' },
  { key: '02', value: 'Cheque nominativo' },
  { key: '03', value: 'Transferencia electrónica de fondos' },
  { key: '04', value: 'Tarjeta de crédito' },
  { key: '05', value: 'Monedero electrónico' },
  { key: '06', value: 'Dinero electrónico' },
  { key: '08', value: 'Vales de despensa' },
  { key: '12', value: 'Dación en pago' },
  { key: '13', value: 'Pago por subrogación' },
  { key: '14', value: 'Pago por consignación' },
  { key: '15', value: 'Condonación' },
  { key: '17', value: 'Compensación' },
  { key: '23', value: 'Novación' },
  { key: '24', value: 'Confusión' },
  { key: '25', value: 'Remisión de deuda' },
  { key: '26', value: 'Prescripción o caducidad' },
  { key: '27', value: 'A satisfacción del acreedor' },
  { key: '28', value: 'Tarjeta de débito' },
  { key: '29', value: 'Tarjeta de servicios' },
  { key: '30', value: 'Aplicación de anticipos' },
  { key: '31', value: 'Intermediario pagos' },
  { key: '99', value: 'Por definir' },
];

module.exports = wayToPayMethod;
